// Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography } from '@mui/material';
import "../../src/pages/css/login.css"

export default function Login() {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = () => {
        // 실제 인증 로직은 이곳에 (예: API 호출)
        if (username === 'swits' && password === 'swits') {
            alert('로그인 성공')
            localStorage.setItem('isAuthenticated', 'true');
            navigate('/');
        } else {
            alert('아이디 또는 비밀번호가 틀렸습니다.');
        }
    };

    return (
        <div className='loginWrapper'>
            <div className='bgWrapper'>
                <div class="bg"></div>
                <div class="bg"></div>
            </div>
            <Box className="loginBox"height="100vh">
                {/* <Typography variant="h4" gutterBottom>로그인</Typography> */}
                <div className='logo'><img src='/images/loginLogo.png' alt='수원시 로고'></img></div>
                <div className='inputWrap'>
                    <TextField
                    className='idInput'
                    label="아이디" 
                    variant="outlined" 
                    margin="normal" 
                    value={username} 
                    onChange={(e) => setUsername(e.target.value)}
                    InputProps={{
                        style: { color: 'white' }, // 입력 텍스트 색상
                    }}
                    InputLabelProps={{
                        style: { color: 'white' }, // 라벨 색상
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: 'rgba(255, 255, 255, 0.1)', // 기본 테두리 색상
                        },
                        '&:hover fieldset': {
                            borderColor: '#04befe', // 호버 시 테두리 색상
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#04befe', // 포커스 시 테두리 색상
                        },
                        borderRadius:0,
                        },
                    }}  />
                    <TextField 
                    className='pwInput'
                    label="비밀번호" 
                    variant="outlined" 
                    margin="normal" 
                    type="password" 
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)} 
                    InputProps={{
                        style: { color: 'white' }, // 입력 텍스트 색상
                    }}
                    InputLabelProps={{
                        style: { color: 'white' }, // 라벨 색상
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: 'rgba(255, 255, 255, 0.1)', // 기본 테두리 색상
                        },
                        '&:hover fieldset': {
                            borderColor: '#04befe', // 호버 시 테두리 색상
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#04befe', // 포커스 시 테두리 색상
                        },
                        borderRadius:0,
                        },
                    }}/>
                </div>
                <div className='btnWrap'>
                    {/* <Button variant="contained" onClick={handleLogin} sx={{ width: '100%', height: '100%' }}><span>로그인</span></Button> */}
                        <a  className="loginBtn"href="#" onClick={handleLogin}>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            로그인
                        </a>
                </div>
            </Box>
        </div>
    );
}
